import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {UserService} from '../../../../core/services/user.service';
import {RegistrationService} from '../../../customer-registration/services/registration.service';
import { IProductFilter } from '../models/product-filter.interface';

@Component({
    selector: 'eci-product-filter',
    templateUrl: './product-filter.component.html',
    styleUrls: ['./product-filter.component.scss']
})
export class ProductFilterComponent implements OnInit {
    @Input() totalProduct: number = 0;
    @Output() public onFilter: EventEmitter<IProductFilter> = new EventEmitter<IProductFilter>();
    @Output() public onCompanyUpdate: EventEmitter<string|number> = new EventEmitter<string|number>();
    public statusList = [
        {name: 'All', value: 'all'},
        {name: 'Not Available', value: 0},
        {name: 'Available', value: 1}];
    form: FormGroup;

    previousePageUsers: number = 0;
    searchUser: FormControl = new FormControl('');
    listOfCompanies: any[] = [];
    listOfUsers: any[] = [];
    tempSeach: string;
    totalPagesUsers: number = 1;
    availablelistOfUsers: any[] = [];

    constructor(
        public userSvc: UserService,
        private formBuilder: FormBuilder,
        private regSvc: RegistrationService,
    ) {
    }

    ngOnInit(): void {
        this.form = this.initializeForm();
        if (this.isAdmin) {
            this.getListOfUsers();
            this.onUserSearch();
        }
    }

    private onUserSearch(): void {
        this.searchUser.valueChanges.pipe(debounceTime(500))
            .subscribe((value) => {
                this.previousePageUsers = 1;
                this.tempSeach = this.searchUser.value;
                if (this.searchUser.value !== '') {
                    this.getListOfUsers(this.previousePageUsers, value, 20);
                }
            });
    }

    initializeForm(): FormGroup {
        return this.formBuilder.group({
            searchStr: new FormControl(''),
            companyId: new FormControl('all', this.canAdd ? [Validators.required] : null),
            status: new FormControl('all'),
        });
    }

    get canAdd(): boolean {
        return this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin || this.userSvc.isOfflineCustomer;
    }

    get isAdmin(): boolean {
        return this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin;
    }

    public getListOfUsers(
        page: number = this.previousePageUsers + 1,
        q: string = this.searchUser.value,
        limit: number = 20,
    ): void {
        this.regSvc.getEcommerceCompanyList(q, limit, page)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.listOfCompanies = data.items;
                if (this.searchUser.value && !data.items) {
                    this.listOfUsers = [{id: 'all', name: 'All'}, ...data.items];
                } else {
                    if (data.meta.currentPage > 1) {
                        this.listOfUsers = [...this.listOfUsers, ...data.items];
                    } else {
                        this.listOfUsers = [{id: 'all', name: 'All'}, ...data.items];
                    }
                }
                this.tempSeach = this.searchUser.value;
                this.previousePageUsers = data.meta.currentPage;
                this.totalPagesUsers = data.meta.totalPages;
                this.availablelistOfUsers = this.listOfUsers;
            });
    }
    public updateCompany(event): void {
        this.onCompanyUpdate.emit(event.value);
    }

    public search(): void {
        const companyId = this.userSvc.isOfflineCustomer ?
            this.userSvc.userStorage?.company?.id :
            this.form.controls.companyId.value ? this.form.controls.companyId.value : 'all';

        this.onFilter.emit({
            companyId,
            q: this.form.get('searchStr').value,
            status: this.form.get('status').value,
        });
    }

}
